import {
    IB_TREES_FETCH,
    IB_TREES_IS_FETCING,
    IB_TREES_API,
    IB_TREE_EDIT,
    IB_TREE_FILTER,
    SET_IBTREE_PROFILE,
    SET_IBTREE_IB,
} from 'constants/ibTrees'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Propfiles
export const ibTreeSave = (data) => (dispatch, state) => {
    dispatch(ibTreesIsFetching(true))
    return post(IB_TREES_API.replace('$profileId', data.profileId), data)
        .then((e) => { dispatch(ibTreesIsFetching(false)); return e; })
        .catch((e) => { dispatch(ibTreesIsFetching(false)); throw new Error(e) })
}

//Edit Propfiles
export const ibTreeEditSave = (data) => (dispatch, state) => {
    dispatch(ibTreesIsFetching(true))
    return put(IB_TREES_API.replace('$profileId', data.profileId), data)
        .then((e) => { dispatch(ibTreesIsFetching(false)); return e; })
        .catch((e) => { dispatch(ibTreesIsFetching(false)); throw new Error(e) })
}



//Feth ibTree by id
export const ibTreeFetch = (id) => (dispatch, state) => {
        dispatch(ibTreesIsFetching(true));
        return get(IB_TREES_API + '/' + id)
            .then((e) => { dispatch(ibTreesIsFetching(false)); return e; })
    }
    //Feth all ibTrees
export const ibTreesFetch = (profileId, ibId) => (dispatch, state) => {
    dispatch(ibTreesIsFetching(true));

    //const filter = state().ibTrees.pageable.filter
    const filter = state().ibTrees.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    let params = {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        };

    let api = Object.keys(filter.filter).reduce((str, el) => str.replace('$' + el, filter.filter[el]), IB_TREES_API);
    return get(api,params)

    //Array->Obj[ibTreeId]{...ibTreeinformation}
    //for easy access of ibTree by his id
    .then((e) => {
            dispatch(ibTreesFetched(e))
            return e
        })
        .then((e) => {
            dispatch(
                ibTreeFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .then((e) => { dispatch(ibTreesIsFetching(false)); return e; })
        .finally(e => dispatch(ibTreesIsFetching(false)))
}

export const ibTreeAvalableFetch = (data) => (dispatch) => {
	dispatch(ibTreesIsFetching(true))

	return get(IB_TREES_API.replace('$profileId', data.profileId) + '/available')
			.then((e) => {
					dispatch(ibTreesFetched(e))
					return e
			})
			.finally(e => dispatch(ibTreesIsFetching(false)))
}

export const profileIbTreeFetch = (data) => (dispatch) => {
	dispatch(ibTreesIsFetching(true))

	return get(IB_TREES_API.replace('$profileId', data.profileId))
			.then((e) => {
					dispatch(ibTreesFetched(e))
					return e
			})
			.finally(e => dispatch(ibTreesIsFetching(false)))
}

//Remove one ibTree
export const ibTreeRemove = (profileId, ibId) => (dispatch, state) => {
    dispatch(ibTreesIsFetching(true))
    return remove(IB_TREES_API.replace('$profileId', profileId) + '/' + ibId)
        .then((e) => {
            dispatch(ibTreesIsFetching(false));
            return e;
        }).catch((e) => { 
            dispatch(ibTreesIsFetching(false));
            throw new Error(e); 
        });
}
export const ibTreesFetched = (payload) => ({ type: IB_TREES_FETCH, payload: payload })
export const ibTreesIsFetching = (payload) => ({ type: IB_TREES_IS_FETCING, payload: payload })
export const ibTreeEdit = (id, data) => ({ type: IB_TREE_EDIT, payload: data })
export const ibTreeFilter = (data) => ({ type: IB_TREE_FILTER, payload: data })
export const setIbTreeProfile = (data) => ({ type: SET_IBTREE_PROFILE, payload: data })
export const setIbTreeIb = (data) => ({ type: SET_IBTREE_IB, payload: data })


// WEBPACK FOOTER //
// ./src/actions/ibTrees.js